<template>
  <div>
    <van-list v-model="isLoading" :finished="isFinished" finished-text="没有更多了" @load="fetchData">
      <dl class="users-list" v-if="!isInit && (list && list.length>0)">
        <dt class="users-title">
          <span class="title">我喜欢的人</span>
        </dt>
        <dd class="users-item" v-for="(item, index) in list" :key="index" @click="jump(item)">
          <div class="head-box">
            <div class="img-box">
              <img v-lazy="item.headPicUrl" alt="" class="img" />
            </div>
          </div>
          <div class="infomation">
            <p class="name-box">
              <span class="name">{{item.nickName}}</span>
              <span class="status" :class="{read: item.ifBeenRead}">{{ item.ifBeenRead ? '已读' : '未读'}}</span>
            </p>
            <p class="sentence" v-if="item.like">对方回点了喜欢，TA的微信已公开，快来看看</p>
            <p class="sentence" v-else>
              现居{{`${parseInt(item.cityId) === 900000 ? (item.country + ' ' + item.state) : areaData['city_list'][item.cityId]}`}}
              {{item.age}}岁 {{item.high}}cm {{educationMap[item.education]}}
              {{item.ifStudent ? '在读' : item.job}}</p>
          </div>
        </dd>
      </dl>
    </van-list>

    <dl class="users-list" v-if="!isInit && (!list || list.length === 0)">
      <dt class="users-title">
      </dt>
      <dd>
        <p class="no-message-tips">当前暂无喜欢我的人</p>
        <img src="~@/assets/img/no-search-result.png" alt="" class="no-message-img" />
      </dd>
    </dl>

    <banModal v-model="showModal" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import banModal from './component/banModal'

export default {
  name: 'Like',
  components: {
    banModal
  },
  data () {
    return {
      isLoading: false,
      isFinished: false,
      currentPage: 1,
      pageSize: 20,
      isInit: true,
      list: [],
      showModal: false
    }
  },
  computed: {
    ...mapState({
      educationMap: 'educationMap',
      areaData: 'areaData'
    }),
    ...mapGetters({
      userId: 'userId'
    })
  },
  methods: {
    fetchData () {
      this.$root.openLoading()
      this.isLoading = true
      this.$http('/api/member/action/list', {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        actionType: 20
      }, 'get').then(res => {
        this.isLoading = false
        if (res.code === '0000' && res.data) {
          const data = res.data
          if (this.currentPage === 1) {
            this.list = data.data
          } else {
            this.list = [...this.list, ...data.data]
          }
          try {
            if (this.pageSize > data.data.length || !this.userId) {
              this.isFinished = true
            }
          } catch (err) {
            this.isFinished = true
          }
          this.currentPage++
        } else {
          this.isFinished = true
          this.$toast(res.msg)
        }
      }, err => {
        this.isFinished = true
        this.isLoading = false
        this.$toast(err)
      }).finally(() => {
        this.isInit = false
        this.$root.closeLoading()
      })
    },
    jump (item) {
      if (item.singleStatus === 6 || item.singleStatus === 7) {
        this.showModal = true
      } else {
        this.$router.push({
          path: `/info-${item.mid}.html`
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
.users-list {
  .name-box {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
  }
  .status {
    width: 56px;
    color: #9B9B9B;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    border: 1px solid rgba(200,200,200,0.2);
    border-radius: 4px;
    background: rgba(213,213,213,0.6);
    &.read {
      color: rgba($mainColor, 0.4);
      border: 1px solid rgba($mainColor, 0.4);
      background: rgba($mainColor, 0.1);
    }
  }
}
</style>
